import { render, staticRenderFns } from "./payment-add-ticket.vue?vue&type=template&id=1c485218&scoped=true&"
import script from "./payment-add-ticket.vue?vue&type=script&lang=js&"
export * from "./payment-add-ticket.vue?vue&type=script&lang=js&"
import style0 from "./payment-add-ticket.vue?vue&type=style&index=0&id=1c485218&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c485218",
  null
  
)

export default component.exports